module.exports = "pegasus_template/assets/blocks/header-fall-1.png";